import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
// import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton';

import placeholder from '../images/project/placehlder.jpg'

const Loading = () => {
    return (
        <>
            <div className="col-md-4">
                <Skeleton height={350} />
            </div>
            <div className="col-md-4">
                <Skeleton height={350} />
            </div>
            <div className="col-md-4">
                <Skeleton height={350} />
            </div>
            <div className="col-md-4">
                <Skeleton height={350} />
            </div>
            <div className="col-md-4">
                <Skeleton height={350} />
            </div>

        </>
    )
}

const ShowProducts = ({filter}) => {
    return (
        <>
            {
                filter?.map((project) => {
                    return (
                        <div className='col-md-4'>
                            <div className='imgWrap' style={{backgroundImage:`url(${placeholder})`, backgroundSize: "contain", backgroundRepeat:"no-repeat", backgroundPosition:"center", border:"1px solid #99be77" }}>
                                <img src={project?.image} alt='portfolio' />
                                {/* <figcaption>
                                    <Link to="" onClick={() => window.open(`${project?.url}`)}>Check it out</Link>
                                </figcaption> */}
                            </div>
                            <h6> "{project?.title}" </h6>
                        </div>
                    )
                })
            }
        </>
    )
}

function Projects() {

    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(data);
    const [loading, setLoading] = useState(false);

    let componentMounted = true;

    useEffect(() => {
        const getProducts = async () => {
            setLoading(true);
            const response = await fetch("https://api.npoint.io/ac121e03fe6f665a8d96/projects");
            if (componentMounted) {
                setData(await response.clone().json());
                setFilter(await response.json())
                setLoading(false);
                // console.log(filter)
            }
            // return () => {
            //     componentMounted = false;
            // }
        }
        getProducts();
    }, [])


    const setFilterProduct = (technology) => {
        const updatedList = data.filter((x) => x.technology === technology);
        setFilter(updatedList);
    }


    return (
        <Layout>
            <section className='projects-sec'>
                <h3>Projects</h3>
                <h2>Portfolio</h2>

                <div className='buttons-wrapper'>
                    <button onClick={() => setFilter(data)}>All</button>
                  
                    <button onClick={() => setFilterProduct("react-redux")}>Reactjs / Redux</button>
                    <button onClick={() => setFilterProduct("Javascript")}>Javascript</button>
                    <button onClick={() => setFilterProduct("react-native")}>React Native</button>
                </div>
               
                <p>These all projects belongs to all of the companies where I work and my personal work as well</p>

                <div className='container-fluid p-0'>
                    <div className='row'>
                    {loading ? <Loading /> : <ShowProducts filter={filter} />}

                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default Projects